export default __webpack_public_path__ + "static/media/2.03a7cf52.jpg";